import { css } from '@emotion/react';
import t from 'react-translate';
import { standardSpacing } from 'styles/global_defaults/scaffolding';


type FlyerInfoProps = {
  requirements?: string;
  includeRequirements?: boolean;
  benefits?: string;
  includeBenefits?: boolean;
  expectations?: string;
  includeExpectations?: boolean;
};

const FlyerInfo = ({
  requirements,
  includeRequirements,
  benefits,
  includeBenefits,
  expectations,
  includeExpectations,
}: FlyerInfoProps) => {
  const styles = css`
    gap: ${standardSpacing}px;

    .info-section {
      max-width: 400px;
    }
`;

  if (
    (!includeRequirements || !requirements)
    && (!includeBenefits || !benefits)
    && (!includeExpectations || !expectations)
  ) {
    return null;
  }

  return (
    <div className='d-flex justify-content-center py-5 border-top border-gray-6' css={styles}>
      {includeRequirements && requirements && (
        <div className='info-section'>
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHO_THIS_IS_FOR()}
          </div>
          <div>{requirements}</div>
        </div>
      )}
      {includeBenefits && benefits && (
        <div className='info-section'>
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHY_JOIN()}
          </div>
          <div>{benefits}</div>
        </div>
      )}
      {includeExpectations && expectations && (
        <div className='info-section'>
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHAT_TO_EXPECT()}
          </div>
          <div>{expectations}</div>
        </div>
      )}
    </div>
  );
};

export default FlyerInfo;
